import { FormQua007 } from './../../entity/forms/form-qua007';
import { FormularioService } from './../../services/formulario.service';
import { NotificationService } from './../../services/notification.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { GeneralService } from 'src/app/services/general.service';
import { Qua007CardIIComponent } from './partialViews/qua007-card-II.component';
import { Qua007CardIComponent } from './partialViews/qua007-card-I.component';
import { Qua007CardIIIComponent } from './partialViews/qua007-card-III.component';
import { Qua007CardIVComponent } from './partialViews/qua007-card-IV.component';
import { Qua007CardVComponent } from './partialViews/qua007-card-V.component';
import { Qua007CardVIComponent } from './partialViews/qua007-card-VI.component';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { BehaviorSubject } from 'rxjs';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { take } from 'rxjs/operators';
import { TonHrLnService } from 'src/app/services/tonHrLn.service';
import { FxAzService } from 'src/app/services/fxaz.service';
import { MatDialog } from '@angular/material/dialog';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import * as moment from 'moment';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import { QuaCaixas } from 'src/app/entity/models/qua-caixas-item';
import { GeneralComponent } from 'src/app/shared/general.component';

@Component({

  selector: 'app-form-qua007',
  templateUrl: './form-qua007.component.html'
})

export class FormQua007Component implements OnInit, AfterViewInit {

  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public showButtonSync = false;
  public formQua007: FormQua007 = new FormQua007();
  public regexDate: string = '\^((0[1-9]|[12][0-9]|3[01])[/]?(0[1-9]|1[0-2])[/]?[12][0-9]{3})';
  public regexHour: string = '\^([0-1]{1}[0-9]{1}|[2][0-3]{1})[:]?([0-5]{1}[0-9]{1})';
  regexLoteRwPet = '\^([a-zA-Z]{6}[0-9]{4})$|([a-zA-Z]{6}[0-9]{4}[;]{1})+([a-zA-Z]{6}[0-9]{4}[;]?)|([a-zA-Z]{1}[0-9]{1}[a-zA-Z]{3}[0-9]{4})|([A-Z][0-9][A-Z]{5}[0-9]{3})'
  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";
  public areaSelect: string = localStorage.getItem('area-select') || null

  @ViewChild(Qua007CardIComponent, { static: false }) qua007CardIComponent: Qua007CardIComponent;
  @ViewChild(Qua007CardIIComponent, { static: false }) qua007CardIIComponent: Qua007CardIIComponent;
  @ViewChild(Qua007CardIIIComponent, { static: false }) qua007CardIIIComponent: Qua007CardIIIComponent;
  @ViewChild(Qua007CardIVComponent, { static: false }) qua007CardIVComponent: Qua007CardIVComponent;
  @ViewChild(Qua007CardVComponent, { static: false }) qua007CardVComponent: Qua007CardVComponent;
  @ViewChild(Qua007CardVIComponent, { static: false }) qua007CardVIComponent: Qua007CardVIComponent;
  totalCaixas: any;

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formBuilder: FormBuilder,
    protected generalService: GeneralService,
    protected notificationService: NotificationService,
    protected formularioService: FormularioService,
    protected route: ActivatedRoute,
    protected tonHrLnService: TonHrLnService,
    protected fxAzService: FxAzService,
    protected resumeAllFormsService: ResumeAllFormsService,
    public dialog: MatDialog) {

    this.formulario = this.formQua007.CreateForm(formBuilder);
  }

  async ngAfterViewInit(): Promise<void> {
    this.route.data.subscribe(async (data: any) => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();;

        const type = (this.route?.snapshot?.params?.type);
        const isReadOnly: boolean = type === '2' ? true : false;
        this.loadingSubject.next(isReadOnly ? false : true);
        if (type === '1' || type === '2') {
          if (type === '1') {
            this.header = this.generalService.createHeader(EnumForm.FormQua007, EnumFormType.Edit);
          } else {
            this.header = this.generalService.createHeader(EnumForm.FormQua007, EnumFormType.Details);
          }

          if (data.formulario.offline) {
            this.showButtonSync = true;
          }
          await this.updateForm(data);
        } else {

          this.header = this.generalService.createHeader(EnumForm.FormQua007, EnumFormType.New);
          await this.getUser();
          this.fillCreatedBy();
          this.qua007CardIComponent.disableCerar = false;
          this.qua007CardIComponent.disableNumeroCampo = false;
          this.qua007CardIComponent.disableBtnCerar = false;
          this.qua007CardIComponent.formulario.get('Site_recebimento').setValue(this.generalService.getLocalStorageDataSite());
          if (this.areaSelect.includes('Pré-Básica')) {
            this.qua007CardIComponent.formulario.get('Site_origem').setValue(this.generalService.getLocalStorageDataSite());
          }
        }
      }
    });
  }


  async ngOnInit(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    this.header = this.generalService.createHeader(EnumForm.FormQua007, EnumFormType.New);
    this.btnCollapse = true;
    this.loadingSubject.next(false);
    this.getUser();
    // this.getCountWeekAfterHarvestStart();
    this.sendAlertDiffSevenDays();
  }

  async makeCalculations(event?: any): Promise<void> {
    if (this.areaSelect.includes('Pré-Básica')) {
      return
    }
    await this.getTempoEsperaCampo();
    await this.getTempoPercurso();
    await this.getTempoEsperaPatio();
    await this.getTempoEsperaTransporte();
    await this.getTempoDescarga();
    //await this.getLastMonday();
    //await this.getCountWeekAfterHarvestStart();
    await this.getFormFatNmt();
    await this.getTonHrLns();
    await this.getFormFagData();
    await this.getFormFatrData();
    await this.sendAlertDiffSevenDays();
    await this.getPc003Data();
    await this.getFormFatData();
    this.qua007CardIComponent.getHumidityData()
    this.qua007CardIVComponent.changeCargaTransbordo(null)
    this.qua007CardIVComponent.calcPesoLiquido();
    this.qua007CardVComponent.changeApc(null);


  }

  async makeCalculationsI(event?: any): Promise<void> {
    if (this.areaSelect.includes('Pré-Básica')) {
      return
    }
    await this.getTempoEsperaCampo();
    await this.getTempoPercurso();
    await this.getTempoEsperaPatio();
    await this.getTempoEsperaTransporte();
    await this.getTempoDescarga();
    //await this.getLastMonday();
    //await this.getCountWeekAfterHarvestStart();
    await this.getFormFatNmt();
    await this.getTonHrLns();
    await this.getFormFagData();
    await this.getFormFatrData();
    await this.sendAlertDiffSevenDays();
  }

  async makeCalculationsII(event?: any): Promise<void> {
    if (this.areaSelect.includes('Pré-Básica')) {
      return
    }
    await this.getTempoEsperaCampo();
    await this.getTempoPercurso();
    await this.getTempoEsperaPatio();
    await this.getTempoEsperaTransporte();
    await this.getTempoDescarga();
    //await this.getLastMonday();
    //await this.getCountWeekAfterHarvestStart();
    await this.getFormFatNmt();
    await this.getTonHrLns();
    await this.getFormFagData();
    await this.getFormFatrData();
    await this.sendAlertDiffSevenDays();
    await this.getTempoDescarga();
  }

  async makeCalculationsIII(event?: any): Promise<void> {
    if (this.areaSelect.includes('Pré-Básica')) {
      return
    }
    await this.getTempoEsperaCampo();
    await this.getTempoPercurso();
    await this.getTempoEsperaPatio();
    await this.getTempoEsperaTransporte();
    await this.getTempoDescarga();
    //await this.getLastMonday();
    //await this.getCountWeekAfterHarvestStart();
    await this.getFormFatNmt();
    await this.getTonHrLns();
    await this.getFormFagData();
    await this.getFormFatrData();
    await this.sendAlertDiffSevenDays();
  }

  async makeBlueFlagsCalc(event?: any): Promise<void> {
    if (this.areaSelect.includes('Pré-Básica')) {
      return
    }
    await this.getFxBlueHumidityData();
    await this.getFormFagData();
  }

  async getHarvestWeekAndLastMonday(event?: any): Promise<void> {
    await this.getCountWeekAfterHarvestStart();
    await this.getLastMonday();
    await this.sendAlertDiffSevenDays();
  }

  async save(): Promise<void> {
    const id: number = this.formulario.get('id').value as number ?? 0;
    await this.selectChanged();

    if (await this.validFormsToSave() !== '') {
      return;
    }

    const isAddFlow = id === 0;

    if (isAddFlow && await this.checkCerarExist()) {
      return;
    }

    await this.buildFormulario();
    await this.buildListCaixas()
    this.formulario.get('origem_negocio').setValue(String(this.generalService.areaSelect));
    await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'qua007');
    this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
  }


  public async openConfirmDialog(valoresAlterados: any[], isAddFlow): Promise<void> {

    const values: any[] = valoresAlterados;
    const dialogRef = this.dialog.open(FormModalConfirmComponent, {

      data: {
        valoresAlterados: values,
        isAddFlow

      }

    });
    dialogRef.afterClosed().subscribe(x => {
      if (x.save) {
        const id: number = this.formulario.get('id').value as number;
        this.formularioService.saveForm(id, this.formulario.getRawValue(), 'qua007', 'formqua007');
      }
      else {
        this.resumeAllFormsService.valoresAlterados = [];
      }



    })

  }
  async getForms(): Promise<FormGroup[]> {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.qua007CardIComponent.formulario);
    arrForms.push(this.qua007CardIIComponent.formulario);
    arrForms.push(this.qua007CardIIIComponent.formulario);
    arrForms.push(this.qua007CardIVComponent.formulario);
    arrForms.push(this.qua007CardVComponent.formulario);
    arrForms.push(this.qua007CardVIComponent.formulario);
    return await arrForms;
  }

  async validFormsToSave(): Promise<string> {
    return await this.formularioService.validForm(await this.getForms());
  }

  async cleanAll(): Promise<void> {

    if (this.header.ScreenType === this.generalService.getEnumFormType(
      EnumFormType.New)) {
      await this.formularioService.cleanForm(await this.getForms());
      await this.getUser();
      this.qua007CardIComponent.formulario.get('Site_recebimento').setValue(this.generalService.getLocalStorageDataSite());
    } else {
      const usuario: string = this.qua007CardVIComponent.formulario.get('Resp_lancamento')?.value;
      await this.formularioService.cleanForm(await this.getForms());
      this.qua007CardVIComponent.formulario.get('Resp_lancamento')?.setValue(usuario);
    }
  }


  async collapseAll(): Promise<void> {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.qua007CardIComponent.collapseCard = this.btnCollapse ? false : true;
    this.qua007CardIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.qua007CardIIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.qua007CardIVComponent.collapseCard = this.btnCollapse ? false : true;
    this.qua007CardVComponent.collapseCard = this.btnCollapse ? false : true;
    this.qua007CardVIComponent.collapseCard = this.btnCollapse ? false : true;
  }

  public async buildFormulario(): Promise<void> {
    this.formulario = await this.formQua007.buildForm(this.formulario, await this.getForms(), this.generalService);
  }

  private async updateForm(data?: any): Promise<void> {
    this.formulario.get('id').setValue(data.formulario.id);
    if (data.formulario.hasOwnProperty('offline')) {
      this.formulario.get('offline').setValue(true);
    }
    await this.formQua007.updateForm(data, await this.getForms(), this.generalService);
    if (data?.formulario?.carga_transbordo?.trim()?.toUpperCase() === 'SIM') {
      await this.applyTranshipmentRule();
    }
    if (!this.areaSelect.includes('Pré-Básica')) {

      await this.makeCalculations();
    }
    else {
      this.createPesoItemComponent(data);
      this.verifyFieldRequired()
    }
    // tslint:disable-next-line: max-line-length
    //await this.enableGeracao();
    //await this.enableGleba();
    this.qua007CardIComponent.disableCerar = true;
    this.qua007CardIComponent.disableNumeroCampo = true;
    this.qua007CardIComponent.safraBasicaOld = data.formulario.safra_basica;
    this.qua007CardIComponent.disableBtnCerar = true;
    await this.selectChanged();
    await this.getCountWeekAfterHarvestStart()
    // await this.qua007CardVComponent.changeApc(null);
  }


  selectChanged() {

    const fxFisica = this.qua007CardVIComponent.formulario.get('Faixa_qualidade_fisica')?.value as string;
    if (fxFisica == 'NA') {

      this.qua007CardVIComponent.formulario.get('Faixa_qualidade_fisica').setValue(null);


    }
  }

  // INICIO DO CODIGO DE CALCULO
  private async sendAlertDiffSevenDays(): Promise<void> {

    const dataAtual = new Date()
    dataAtual.setHours(0, 0, 0, 0);

    //ETAPA 2:
    //const dataColheita: string = this.qua007CardIIComponent.formulario.get('Dt_colheita')?.value as string;
    //const colheitaDate = new Date(Number(dataColheita.substr(4)), Number(dataColheita.substr(2,4)) - 1,Number(dataColheita.substr(0, 2)), 0, 0, 0, 0);
    //console.log(`dataColheita: ${dataColheita}`);
    //console.log(`colheitaDate: ${colheitaDate}`);

    //const dataTerminoEnchimentoData: string = this.qua007CardIIComponent.formulario.get('Termino_enchimento_data')?.value as string;
    //const terminoEnchimentoDate = new Date(Number(dataTerminoEnchimentoData.substr(4)), Number(dataTerminoEnchimentoData.substr(2,4)) - 1,Number(dataTerminoEnchimentoData.substr(0, 2)), 0, 0, 0, 0);
    //console.log(`dataTerminoEnchimentoData: ${dataTerminoEnchimentoData}`);
    //console.log(`terminoEnchimentoDate: ${terminoEnchimentoDate}`);

    //ETAPA 3:
    //const dataChegadaPatio: string = this.qua007CardIIComponent.formulario.get('Chegada_patio_data')?.value as string;
    //const chegadaPatioDate = new Date(Number(dataChegadaPatio.substr(4)), Number(dataChegadaPatio.substr(2,4)) - 1,Number(dataChegadaPatio.substr(0, 2)), 0, 0, 0, 0);
    //console.log(`dataChegadaPatio: ${dataChegadaPatio}`);
    //console.log(`chegadaPatioDate: ${chegadaPatioDate}`);



    //CALCULO:
    //const diffDates = dataAtual.getTime() - colheitaDate.getTime();
    //const diffDays = Number(Math.ceil(diffDates / (1000 * 3600 * 24)));


    //VERIFICAÇÃO:
    //if(diffDays > 7 || diffDays < -7){
    //  this.notificationService.sendNotification('', TypeMessage.DiffDias, ActionMessage.Warning);
    //}

  }

  public async getFormFagData(event?: any): Promise<void> {
    const fxAzulCampo = this.qua007CardVIComponent.formulario.get('Fx_azul_campo')?.value as string;
    const fxAzulUmidade = this.qua007CardVIComponent.formulario.get('Fx_azul_umidade')?.value as string;
    const fxAzulTemperatura = this.qua007CardVIComponent.formulario.get('Fx_azul_temperatura')?.value as string;
    const fxAzulTempo = this.qua007CardVIComponent.formulario.get('Fx_azul_tempo_nmonitorado')?.value as string;
    const pFxAzulTransbordo = this.qua007CardVIComponent.formulario.get('Fx_azul_transbordo')?.value as string;
    // tslint:disable-next-line: max-line-length
    // if (!!fxAzulCampo && !!fxAzulUmidade && !!fxAzulTemperatura && !!fxAzulTempo) {
    const resultado: string = await this.fxAzService?.calcFaixaAzulGeral(fxAzulCampo, fxAzulUmidade, fxAzulTemperatura, fxAzulTempo, pFxAzulTransbordo);
    this.qua007CardVIComponent.formulario.get('Fx_azul_geral').setValue(resultado);
    //}
  }

  public async getFormFatrData(event?: any): Promise<void> {
    const cargaTransbordo = this.qua007CardIVComponent.formulario.get('Carga_transbordo')?.value?.trim()?.toUpperCase() as string;
    //console.log(`teste carga transbordo: ${cargaTransbordo}`)

    let tempoTransbordo = this.qua007CardIVComponent.formulario.get('Tempo_transbordo')?.value as number;


    if (!!cargaTransbordo && !!tempoTransbordo) {
      const resultado: string = await this.fxAzService.calcFaixaAzulPorTransbordo(cargaTransbordo, tempoTransbordo);
      this.qua007CardVIComponent.formulario.get('Fx_azul_transbordo').setValue(resultado);
      //console.log('IfgetFormFatrData');
    } else {
      this.qua007CardVIComponent.formulario.get('Fx_azul_transbordo').setValue('NÃO');
      //console.log('ElsegetFormFatrData');
    }
    await this.getFormFagData();
  }

  public async getPc003Data(event?: any): Promise<void> {
    const contratoJuridico = this.qua007CardIComponent.formulario.get('Contrato_Juridico')?.value as string;
    const isComercialContract = contratoJuridico.toUpperCase().includes('M');

    // FUNCAO PARA BUSCAR DADOS PC003 PARTINDO SOMENTE DO CONTRATO

    if (isComercialContract && !!contratoJuridico && contratoJuridico?.length >= 10) {
      await this.formularioService.getPc003Data(contratoJuridico).pipe(take(1)).toPromise().then(async (objPc003: any) => {
        this.qua007CardIComponent.formulario.get('Safra').setValue(objPc003?.data?.safra);
        this.qua007CardIComponent.formulario.get('Cooperante').setValue(objPc003?.data?.cooperante);
        this.qua007CardIComponent.formulario.get('Nr_campo').setValue(objPc003?.data?.numero_campo);
        this.qua007CardIComponent.formulario.get('Hibrido').setValue(objPc003?.data?.hibrido_rnc);
        //this.qua007CardIComponent.formulario.get('Gleba').setValue(objPc003?.data?.gleba);
        const distanciaStr = objPc003?.data?.distancia_campo; // Pegando o valor da string
        const distanciaNum = distanciaStr ? parseFloat(distanciaStr.replace(',', '.')) : null; // Convertendo
        this.qua007CardIIIComponent.formulario.get('Distancia_campo').setValue(distanciaNum);
        this.qua007CardIComponent.formulario.get('Especie').setValue(objPc003?.data?.especie);
        //this.qua007CardIComponent.formulario.get('Tp_colheita').setValue(objPc003?.data?.tipo_colheita);

        this.qua007CardIComponent.formulario.get('Geracao').setValue(objPc003?.data?.geracao);

        this.qua007CardIComponent.formulario.get('Site_origem').setValue(objPc003?.data?.site_origem);

        //await this.enableGleba();
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao contrato juridico ${contratoJuridico}. Entre em contato com o Administrador.`);
      });
      await this.getFxBlueHumidityData();
      await this.getCountWeekAfterHarvestStart();
      //await this.getTonHrLns();
    } else if (!isComercialContract && !!contratoJuridico && contratoJuridico?.length >= 10) {
      await this.formularioService.getPc003Data(contratoJuridico).pipe(take(1)).toPromise().then(async (objPc003: any) => {
        this.qua007CardIComponent.formulario.get('Safra').setValue(objPc003?.data?.safra);
        this.qua007CardIComponent.formulario.get('Cooperante').setValue(objPc003?.data?.cooperante);
        this.qua007CardIComponent.formulario.get('Nr_campo').setValue(objPc003?.data?.numero_campo);
        this.qua007CardIComponent.formulario.get('Site_origem').setValue(objPc003?.data?.site_origem);
        //this.qua007CardIComponent.formulario.get('Gleba').setValue(objPc003?.data?.gleba);
        this.qua007CardIComponent.formulario.get('Hibrido').setValue(objPc003?.data?.hibrido_rnc);
        this.qua007CardIComponent.formulario.get('Especie').setValue(objPc003?.data?.especie);
        //this.qua007CardIComponent.formulario.get('Tp_colheita').setValue(objPc003?.data?.tipo_colheita);
        this.qua007CardIComponent.formulario.get('Geracao').setValue(objPc003?.data?.geracao);
        //await this.enableGleba();
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao contrato juridico ${contratoJuridico}. Entre em contato com o Administrador.`);
      });
      await this.getFxBlueHumidityData();
      await this.getCountWeekAfterHarvestStart();
      //await this.getTonHrLns();
    }
  }

  public async getHumidityData(objHumidity?: any): Promise<void> {
    if (!!objHumidity) {
      this.qua007CardIIComponent.formulario.get('Umidade').setValue(objHumidity as number);
      await this.getFxBlueHumidityData();
      //TODO: Alterar o nome do endpoint para o que foi criado no backend e testar o retorno do resultado descomentando o metodo abaixo.
      // await this.getDataFromSdcDespalha();
    } else {
      this.qua007CardIIComponent.formulario.get('Umidade').setValue(0);
      await this.getFxBlueHumidityData();
      //TODO: Alterar o nome do endpoint para o que foi criado no backend e testar o retorno do resultado descomentando o metodo abaixo.
      // await this.getDataFromSdcDespalha();
    }
  }

  public async getFxBlueHumidityData(event?: any): Promise<void> {
    const umidade = this.qua007CardIIComponent.formulario.get('Umidade')?.value as number ?? 0;
    const hibrido = this.qua007CardIComponent.formulario.get('Hibrido')?.value as string;
    const safra = this.qua007CardIComponent.formulario.get('Safra')?.value as string;
    const tipoColheita: string = this.qua007CardIComponent.formulario.get('Tp_colheita')?.value;

    if (!!hibrido && hibrido?.length > 0) {
      await this.formularioService.getFxBlueHumidityData(umidade.toString(), hibrido, tipoColheita, safra).pipe(take(1)).toPromise().then((response: any) => {
        this.qua007CardVIComponent.formulario.get('Fx_azul_umidade').setValue(response?.data as string);
        this.getFormFagData();
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, ``, TypeMessage.CalcErrorFxUmidade);
      });
    }
  }

  public async getFormFatData(event?: any): Promise<void> {
    const tempMaxTrajeto: number = this.qua007CardVComponent.formulario.get('Temp_max_trajeto')?.value;
    const tempMaxTransporte: number = this.qua007CardVComponent.formulario.get('Temp_max_total_transporte')?.value;
    //const tipoColheita: string = this.qua007CardIComponent.formulario.get('Tp_colheita')?.value;
    const tempoEsperaPatio: number = this.qua007CardIVComponent.formulario.get('Tempo_espera_patio')?.value;
    const tempoTotalTransporte: number = this.qua007CardIVComponent.formulario.get('Tempo_total_transporte')?.value;

    if (!!tempMaxTrajeto || !!tempMaxTransporte) {
      const resultado: string = await this.fxAzService.calcFaixaAzulTemperatura(tempMaxTrajeto, tempMaxTransporte);
      this.qua007CardVIComponent.formulario.get('Fx_azul_temperatura').setValue(resultado);
    } else {
      this.qua007CardVIComponent.formulario.get('Fx_azul_temperatura').setValue('N/A');
    }
    await this.getFormFatNmt();
    await this.getFormFagData();
  }

  public async getTonHrLns(event?: any): Promise<void> {
    const pesoLiquido: number = this.qua007CardIVComponent.formulario.get('Peso_liquido')?.value;
    const tempoDescarga: number = this.qua007CardVComponent.formulario.get('Tempo_descarga')?.value;
    const linhaDescarga: string = this.qua007CardVComponent.formulario.get('Linha_descarga')?.value;
    const siteRecebimento: string = this.qua007CardIComponent.formulario.get('Site_recebimento')?.value;

    if (!!pesoLiquido && !!tempoDescarga && !!linhaDescarga && !!siteRecebimento) {
      const resultado: number = await this.tonHrLnService.calcToneladasHorasLanes(siteRecebimento, tempoDescarga, linhaDescarga, pesoLiquido);
      this.qua007CardVIComponent.formulario.get('Tonhrlanes').setValue(Number(resultado.toFixed(3)));
    }
  }

  private async getFormFatNmt(): Promise<void> {
    const tempoEsperaPatio: number = this.qua007CardIVComponent.formulario.get('Tempo_espera_patio')?.value;
    const tempoTotalTransporte: number = this.qua007CardIVComponent.formulario.get('Tempo_total_transporte')?.value;
    const tipoColheita: string = this.qua007CardIComponent.formulario.get('Tp_colheita')?.value;
    const tempMaxTrajeto: number = this.qua007CardVComponent.formulario.get('Temp_max_trajeto')?.value;
    const tempMaxTransporte: number = this.qua007CardVComponent.formulario.get('Temp_max_total_transporte')?.value;
    const linhaDescarga: string = this.qua007CardVComponent.formulario.get('Linha_descarga')?.value;

    if ((!!tempoEsperaPatio || !!tempoTotalTransporte) && (!!!tempMaxTrajeto && !!!tempMaxTransporte)) {
      const resultado: string = await this.fxAzService.calcFaixaAzulPorTempoMonitorado(tempoEsperaPatio, tempoTotalTransporte, tipoColheita, linhaDescarga);
      this.qua007CardVIComponent.formulario.get('Fx_azul_tempo_nmonitorado').setValue(resultado);
    } else {
      this.qua007CardVIComponent.formulario.get('Fx_azul_tempo_nmonitorado').setValue('N/A');
    }
    await this.getFormFagData();
  }

  private async getCountWeekAfterHarvestStart(): Promise<void> {
    const siteRecebimento: string = this.getFormCard('Site_recebimento').get('Site_recebimento')?.value;
    const safra: string = this.getFormCard('Safra').get('Safra')?.value;
    let dataColheita: string = this.getFormCard('Dt_colheita').get('Dt_colheita')?.value;
    if (!!siteRecebimento && !!dataColheita && dataColheita?.length >= 8) {
      if (dataColheita?.indexOf('/') === 1) {
        dataColheita = dataColheita?.substr(4, 4) + '-' + dataColheita?.substr(2, 2) + '-' + dataColheita?.substr(0, 2);
      } else {
        dataColheita = this.generalService.createDate(dataColheita)?.toLocaleDateString('fr-CA');
      }
      if (dataColheita?.length >= 9) {
        await this.formularioService.getCountWeekAfterHarvestStart(siteRecebimento, dataColheita, safra).pipe(take(1)).toPromise().then((response: any) => {
          this.getFormCard('Sem_colheita_sequencia').get('Sem_colheita_sequencia').setValue(response?.data);
        }).catch(async (error: HttpErrorResponse) => {
          this.notificationService.showNotificationError(error, error.message);
        });
      }
    }
  }

  private async getLastMonday(): Promise<void> {
    let dataColheita: string = this.getFormCard('Dt_colheita').get('Dt_colheita')?.value as string;
    if (!!dataColheita && dataColheita?.length >= 8) {
      // tslint:disable-next-line: max-line-length
      if (dataColheita?.indexOf('/') === 1) {
        dataColheita = dataColheita?.substr(4, 4) + '-' + dataColheita?.substr(2, 2) + '-' + dataColheita?.substr(0, 2);
      } else {
        dataColheita = this.generalService.createDate(dataColheita)?.toLocaleDateString('fr-CA');
      }
      if (dataColheita?.length >= 9) {
        await this.formularioService.getLastMonday(dataColheita).pipe(take(1)).toPromise().then((response: any) => {
          this.getFormCard('Sem_colheita_data').get('Sem_colheita_data').setValue(response?.data);
        }).catch(async (error: HttpErrorResponse) => {
          this.notificationService.showNotificationError(error, error.message);
        });
      }
    }
  }

  private async getTempoEsperaCampo(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const terminoEnchimentoData: string = this.qua007CardIIComponent.formulario.get('Termino_enchimento_data')?.value;
    const terminoEnchimentoHora: string = this.qua007CardIIComponent.formulario.get('Termino_enchimento_hora')?.value;
    const saidaCampoData: string = this.qua007CardIIComponent.formulario.get('Saida_campo_data')?.value;
    const saidaCampoHora: string = this.qua007CardIIComponent.formulario.get('Saida_campo_hora')?.value;
    // tslint:disable-next-line: max-line-length
    if (terminoEnchimentoData?.length >= 8 && saidaCampoData?.length >= 8 && terminoEnchimentoHora?.length > 0 && saidaCampoHora?.length > 0) {
      const saidaCampo: Date = this.generalService.createDateTimeData(saidaCampoData, saidaCampoHora);
      const tempoEnchimento: Date = this.generalService.createDateTimeData(terminoEnchimentoData, terminoEnchimentoHora);
      // tslint:disable-next-line: max-line-length
      this.qua007CardIIComponent.formulario.get('Tempo_espera_campo').setValue(Number(this.generalService.timeDiffCalc(saidaCampo, tempoEnchimento).toFixed(2)));
    } else {
      this.qua007CardIIComponent.formulario.get('Tempo_espera_campo').setValue(Number('0'));
    }
  }

  private async getTempoPercurso(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const chegadaPatioData: string = this.qua007CardIIIComponent.formulario.get('Chegada_patio_data')?.value;
    const chegadaPatioHora: string = this.qua007CardIIIComponent.formulario.get('Chegada_patio_hora')?.value;
    const saidaCampoData: string = this.qua007CardIIComponent.formulario.get('Saida_campo_data')?.value;
    const saidaCampoHora: string = this.qua007CardIIComponent.formulario.get('Saida_campo_hora')?.value;
    // tslint:disable-next-line: max-line-length
    if (chegadaPatioData?.length >= 8 && saidaCampoData?.length >= 8 && chegadaPatioHora?.length > 0 && saidaCampoHora?.length > 0) {
      const chegadaPatio: Date = this.generalService.createDateTimeData(chegadaPatioData, chegadaPatioHora);
      const saidaCampo: Date = this.generalService.createDateTimeData(saidaCampoData, saidaCampoHora);
      // tslint:disable-next-line: max-line-length
      this.qua007CardIIIComponent.formulario.get('Tempo_percurso').setValue(Number(this.generalService.timeDiffCalc(chegadaPatio, saidaCampo).toFixed(2)));
    } else {
      this.qua007CardIIIComponent.formulario.get('Tempo_percurso').setValue(Number('0'));
    }
  }

  private async getTempoEsperaPatio(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const chegadaPatioData: string = this.qua007CardIIIComponent.formulario.get('Chegada_patio_data')?.value;
    const chegadaPatioHora: string = this.qua007CardIIIComponent.formulario.get('Chegada_patio_hora')?.value;
    const inicioDescargaData: string = this.qua007CardIVComponent.formulario.get('Inicio_descarga_data')?.value;
    const inicioDescargaHora: string = this.qua007CardIVComponent.formulario.get('Inicio_descarga_hora')?.value;
    // tslint:disable-next-line: max-line-length
    if (chegadaPatioData?.length >= 8 && inicioDescargaData?.length >= 8 && chegadaPatioHora?.length > 0 && inicioDescargaHora?.length > 0) {
      const inicioDescarga: Date = this.generalService.createDateTimeData(inicioDescargaData, inicioDescargaHora);
      const chegadaPatio: Date = this.generalService.createDateTimeData(chegadaPatioData, chegadaPatioHora);
      // tslint:disable-next-line: max-line-length
      this.qua007CardIVComponent.formulario.get('Tempo_espera_patio').setValue(Number(this.generalService.timeDiffCalc(inicioDescarga, chegadaPatio).toFixed(2)));
    } else {
      this.qua007CardIVComponent.formulario.get('Tempo_espera_patio').setValue(Number('0'));
    }
  }

  private async getTempoEsperaTransporte(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const inicioDescargaData: string = this.qua007CardIVComponent.formulario.get('Inicio_descarga_data')?.value;
    const inicioDescargaHora: string = this.qua007CardIVComponent.formulario.get('Inicio_descarga_hora')?.value;
    const terminoEnchimentoData: string = this.qua007CardIIComponent.formulario.get('Termino_enchimento_data')?.value;
    const terminoEnchimentoHora: string = this.qua007CardIIComponent.formulario.get('Termino_enchimento_hora')?.value;
    // this.ValidateDescargaDate();
    // tslint:disable-next-line: max-line-length
    if (terminoEnchimentoData?.length >= 8 && inicioDescargaData?.length >= 8 && terminoEnchimentoHora?.length > 0 && inicioDescargaHora?.length > 0) {
      const inicioDescarga: Date = this.generalService.createDateTimeData(inicioDescargaData, inicioDescargaHora);
      const terminoEnchimento: Date = this.generalService.createDateTimeData(terminoEnchimentoData, terminoEnchimentoHora);
      // tslint:disable-next-line: max-line-length
      this.qua007CardIVComponent.formulario.get('Tempo_total_transporte').setValue(Number(this.generalService.timeDiffCalc(inicioDescarga, terminoEnchimento).toFixed(2)));
    } else {
      this.qua007CardIVComponent.formulario.get('Tempo_total_transporte').setValue('');
    }
  }

  private async getTempoDescarga(): Promise<void> {
    const terminoDescargaData: string = this.qua007CardIVComponent.formulario.get('Termino_descarga_data')?.value;
    const terminoDescargaHora: string = this.qua007CardIVComponent.formulario.get('Termino_descarga_hora')?.value;
    const inicioDescargaData: string = this.qua007CardIVComponent.formulario.get('Inicio_descarga_data')?.value;
    const inicioDescargaHora: string = this.qua007CardIVComponent.formulario.get('Inicio_descarga_hora')?.value;
    this.ValidateDescargaDate();
    this.ValidateDescargaHour();

    const cargaTransbordo = this.qua007CardIVComponent.formulario.get('Carga_transbordo')?.value?.trim()?.toUpperCase() as string;
    const tempoTransbordo: number = this.qua007CardIVComponent.formulario.get('Tempo_transbordo')?.value;

    if (terminoDescargaData?.length >= 8 && inicioDescargaData?.length >= 8 && terminoDescargaHora?.length > 0 && inicioDescargaHora?.length > 0) {
      const terminoDescarga: Date = this.generalService.createDateTimeData(terminoDescargaData, terminoDescargaHora);
      const inicioDescarga: Date = this.generalService.createDateTimeData(inicioDescargaData, inicioDescargaHora);
      const calcTempoDescard = cargaTransbordo == 'SIM' ? Number(this.generalService.timeDiffCalc(terminoDescarga, inicioDescarga).toFixed(2)) - tempoTransbordo : Number(this.generalService.timeDiffCalc(terminoDescarga, inicioDescarga).toFixed(2));
      this.qua007CardVComponent.formulario.get('Tempo_descarga').setValue(calcTempoDescard);
    } else {
      this.qua007CardVComponent.formulario.get('Tempo_descarga').setValue('');
    }

    await this.getTonHrLns();
  }
  private async ValidateDescargaDate() {

    const inicioDescargaData: string = this.qua007CardIVComponent.formulario.get('Inicio_descarga_data')?.value;
    const terminoDescargaData: string = this.qua007CardIVComponent.formulario.get('Termino_descarga_data')?.value;

    const rangeDateSecagem: boolean = this.generalService.isValidRangeDate(inicioDescargaData, terminoDescargaData);

    if (rangeDateSecagem === true) {

      this.notificationService.sendNotification('', TypeMessage.InvalidRangeDate, ActionMessage.Error);
      // this.qua007CardIVComponent.formulario.get('Inicio_descarga_data')?.setErrors({ Inicio_descarga_data: true });
      this.qua007CardIVComponent.formulario.get('Termino_descarga_data')?.setErrors({ Termino_descarga_data: true });
    }

  }

  private async ValidateDescargaHour() {

    const inicioDescargaHora: string = this.qua007CardIVComponent.formulario.get('Inicio_descarga_hora')?.value;
    const terminoDescargaHora: string = this.qua007CardIVComponent.formulario.get('Termino_descarga_hora')?.value;
    const inicioDescargaData: string = this.qua007CardIVComponent.formulario.get('Inicio_descarga_data')?.value;
    const terminoDescargaData: string = this.qua007CardIVComponent.formulario.get('Termino_descarga_data')?.value;

    const rangeHourDescarga: boolean = this.generalService.isValidRangeHour(inicioDescargaHora, terminoDescargaHora, inicioDescargaData, terminoDescargaData);

    if (rangeHourDescarga === true) {

      this.notificationService.sendNotification('', TypeMessage.InvalideRangeHour, ActionMessage.Error);
      this.qua007CardIVComponent.formulario.get('Termino_descarga_hora')?.setErrors({ Termino_descarga_hora: true });

    }



  }

  private async applyTranshipmentRule(): Promise<void> {
    const formularioCardIV: FormGroup = this.qua007CardIVComponent.formulario;
    const cargaTransbordo: string = formularioCardIV.get('Carga_transbordo')?.value?.trim()?.toUpperCase();
    if (!!cargaTransbordo && cargaTransbordo === 'SIM') {
      this.qua007CardIVComponent.readOnlyTransbordo = false;
      formularioCardIV.get('Saida_transbordo_data').setValidators([Validators.minLength(8), Validators.pattern(this.regexDate)]);
      formularioCardIV.get('Saida_transbordo_hora').setValidators([Validators.minLength(4), Validators.pattern(this.regexHour)]);
      formularioCardIV.get('Reinicio_descarga_transbordo_data').setValidators([Validators.minLength(8), Validators.pattern(this.regexDate)]);
      formularioCardIV.get('Reinicio_descarga_transbordo_hora').setValidators([Validators.minLength(4), Validators.pattern(this.regexHour)]);
      formularioCardIV.get('Saida_transbordo_data').updateValueAndValidity();
      formularioCardIV.get('Saida_transbordo_hora').updateValueAndValidity();
      formularioCardIV.get('Reinicio_descarga_transbordo_data').updateValueAndValidity();
      formularioCardIV.get('Reinicio_descarga_transbordo_hora').updateValueAndValidity();
    }
    else {
      this.qua007CardIVComponent.readOnlyTransbordo = true;
      formularioCardIV.get('Saida_transbordo_data').setValidators([]);
      formularioCardIV.get('Saida_transbordo_hora').setValidators([]);
      formularioCardIV.get('Reinicio_descarga_transbordo_data').setValidators([]);
      formularioCardIV.get('Reinicio_descarga_transbordo_hora').setValidators([]);
      formularioCardIV.get('Saida_transbordo_data').updateValueAndValidity();
      formularioCardIV.get('Saida_transbordo_hora').updateValueAndValidity();
      formularioCardIV.get('Reinicio_descarga_transbordo_data').updateValueAndValidity();
      formularioCardIV.get('Reinicio_descarga_transbordo_hora').updateValueAndValidity();
    }
  }

  private async getUser(): Promise<void> {
    await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
      this.qua007CardVIComponent.formulario.get('Resp_lancamento').setValue(response['user-profile']?.displayName ?? 'Administrador');
      this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
    }).catch(async error => {
      await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
        this.qua007CardVIComponent.formulario.get('Resp_lancamento').setValue(response ?? 'Administrador');
        this.currentUser = response ?? 'Administrador';
      }).catch(err => {
      });
    });
  }

  private fillCreatedBy(): void {
    this.qua007CardVIComponent.formulario.get('criado_por').setValue(this.currentUser);
  }

  private async checkCerarExist(): Promise<boolean> {
    const cerar: string = this.qua007CardIComponent.formulario.get('Cerar')?.value;
    let result: boolean;
    result = false;
    await this.formularioService.checkValueExists('cerar', 'qua007', cerar).pipe(take(1)).toPromise().then(async (response: any) => {
      if (!!response?.data) {
        if ((response.data as boolean) === true) {
          this.notificationService.sendNotification(`O Cerar ${cerar} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
          result = true;
          this.qua007CardIComponent.formulario.get('Cerar').setErrors({ invalidCerar: true });
        } else {
          this.qua007CardIComponent.formulario.get('Cerar').setErrors({ invalidCerar: false });
        }
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
      if (localStorage.getItem('statusNetwork')) {
        let isOnline = JSON.parse(localStorage.getItem('statusNetwork'));
        if (isOnline) {
          result = true;
          this.qua007CardIComponent.formulario.get('Cerar').setErrors({ invalidCerar: true });
        }
      }
    });
    return result;
  }

  async triggerContractAndSite(event?: any): Promise<void> {
    //await this.enableGleba();
    await this.getTonHrLns();
    await this.getCountWeekAfterHarvestStart();
  }

  private async enableGleba(): Promise<void> {
    const contratoJuridico = this.qua007CardIComponent.formulario.get('Contrato_Juridico')?.value as string;
    const isComercialContract = contratoJuridico.toUpperCase().includes('M');
    //const site_recebimento: string = this.qua007CardIComponent.formulario.get('Site_recebimento')?.value?.toUpperCase() ?? '';
    //const site_origem: string = this.qua007CardIComponent.formulario.get('Site_origem')?.value?.toUpperCase() ?? '';
    if (isComercialContract) {
      this.qua007CardIComponent.readyOnlyGleba = false;
      this.validatorRequired(true);
      // } else if (site_origem === 'CDR' && site_recebimento !== 'PTU-BÁSICA') {
      //     this.qua007CardIIComponent.readyOnlyUmidade = false;
      //     this.validatorRequired(true);
      // } else if (site_origem === 'CDR' && site_recebimento === 'PTU-BÁSICA') {
      //     this.qua007CardIIComponent.readyOnlyUmidade = false;
      //     this.validatorRequired(true);
    } else {
      this.qua007CardIComponent.readyOnlyGleba = true;
      this.validatorRequired(false);
    }
  }

  private async validatorRequired(blRequired?: boolean): Promise<void> {
    if (blRequired) {
      //this.qua007CardIComponent.formulario.get('Gleba').reset();
      this.qua007CardIComponent.formulario.get('Gleba').setValidators([Validators.required]);
    } else {
      this.qua007CardIComponent.formulario.get('Gleba').setValidators([]);
      this.qua007CardIComponent.formulario.get('Gleba').reset();
    }
    this.qua007CardIComponent.formulario.get('Gleba').updateValueAndValidity()
  }

  private async getDataFromSdcDespalha() {
    const cerar: string = this.qua007CardIComponent.formulario.get('Cerar')?.value;
    if (!!cerar) {
      await this.formularioService.getDataFromSdcDespalha(cerar).pipe(take(1)).toPromise().then((response: any) => {
        this.qua007CardVComponent.formulario.get('Controle_secagem').setValue(response?.data.controle_secagem as string);
        this.qua007CardVComponent.formulario.get('Secador_camara').setValue(response?.data.secador_camara as string);
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um erro para buscar os dados de controle secagem e secador camara da SDC Despalha. Entre em contato com o Administrador.`);
      });
    }
  }
  // FIM DO CODIGO DE CALCULO
  public getFormCard(control) {


    if (this.qua007CardIComponent.formulario?.contains(control) || this.qua007CardIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "1");
      return this.qua007CardIComponent.formulario
    }
    else if (this.qua007CardIIComponent.formulario?.contains(control) || this.qua007CardIIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "2");
      return this.qua007CardIIComponent.formulario
    }
    else if (this.qua007CardIIIComponent.formulario?.contains(control) || this.qua007CardIIIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "3");
      return this.qua007CardIIIComponent.formulario
    }
    else if (this.qua007CardIVComponent.formulario?.contains(control) || this.qua007CardIVComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "4");
      return this.qua007CardIVComponent.formulario
    }
    else if (this.qua007CardVComponent.formulario?.contains(control) || this.qua007CardVComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "5");
      return this.qua007CardVComponent.formulario
    }
    else if (this.qua007CardVIComponent.formulario?.contains(control) || this.qua007CardVIComponent.formulario.get(control)?.disabled == true) {
      // console.log(control, "6");
      return this.qua007CardVIComponent.formulario
    }

    else {
      // console.log(control, "1 else");
      return this.qua007CardIComponent.formulario
    }



  }
  // INICIO REGRAS DE NEGOCIO - PET PRE BASICA

  makeCalcPreBasica(event) {
    if (!this.areaSelect.includes('Pré-Básica')) {
      return
    }
    this.makeCalcPreBasicaII();
  }
  private makeCalcPreBasicaII() {
    // Termino_enchimento_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
    // Termino_enchimento_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour)]],
    // Saida_campo_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
    // Saida_campo_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour)]],
    this.validateChronologicalOrder([
      { dataField: 'Dt_colheita', horaField: null, alias: 'Data de colheita' },
      { dataField: 'Termino_enchimento_data', horaField: 'Termino_enchimento_hora', alias: 'Término de enchimento o Data Hora' },
      { dataField: 'Saida_campo_data', horaField: 'Saida_campo_hora', alias: 'Saída Campo Data Hora' },
      { dataField: 'Chegada_patio_data', horaField: 'Chegada_patio_hora', alias: 'Chagada Pátio Data Hora' },
      { dataField: 'Inicio_descarga_data', horaField: 'Inicio_descarga_hora', alias: 'Início Descarga Data Hora' },
      { dataField: 'Termino_descarga_data', horaField: 'Termino_descarga_hora', alias: 'Término Descarga Data Hora' },
      // Adicione outros pares conforme necessário
    ]);
    this.validatePesoItem();
    this.calcTempoPercurso()
    this.calcTempoDescargo();
    this.calcTempoEspera();
    this.verifyFieldRequired()
  }

  private calcTempoPercurso() {
    const dataSaida = this.getFormCard("Saida_campo_data").get('Saida_campo_data').value;
    const horaSaida = this.getFormCard("Saida_campo_hora").get('Saida_campo_hora').value;

    const dataChegadaPatio = this.getFormCard('Chegada_patio_data').get('Chegada_patio_data').value
    const horaChegadaPatio = this.getFormCard('Chegada_patio_hora').get('Chegada_patio_hora').value
    if (!dataChegadaPatio || !horaChegadaPatio || !dataSaida || !horaSaida) {
      return
    }
    const dateTimeA = this.generalService.createDateTimeData(dataChegadaPatio, horaChegadaPatio)
    const dateTimeB = this.generalService.createDateTimeData(dataSaida, horaSaida)
    // const duration = moment.duration(dateTimeA.diff(dateTimeB));

    // const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
    // const minutes = String(duration.minutes()).padStart(2, '0');
    this.getFormCard('Tempo_percurso').get('Tempo_percurso').setValue(this.generalService.timeDiffCalc(dateTimeA, dateTimeB))
  }
  private calcTempoDescargo() {
    const dataInicioDescarga = this.getFormCard("Inicio_descarga_data").get('Inicio_descarga_data').value;
    const horaInicioDescarga = this.getFormCard("Inicio_descarga_hora").get('Inicio_descarga_hora').value;

    const dataTerminoDescarga = this.getFormCard('Termino_descarga_data').get('Termino_descarga_data').value
    const horaTerminoDescarga = this.getFormCard('Termino_descarga_hora').get('Termino_descarga_hora').value
    if (!dataTerminoDescarga || !horaTerminoDescarga || !dataInicioDescarga || !horaInicioDescarga) {
      return
    }
    const dateTimeA = this.generalService.createDateTimeData(dataTerminoDescarga, horaTerminoDescarga)
    const dateTimeB = this.generalService.createDateTimeData(dataInicioDescarga, horaInicioDescarga)
    // const duration = moment.duration(dateTimeA.diff(dateTimeB));

    // const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
    // const minutes = String(duration.minutes()).padStart(2, '0');
    this.getFormCard('Tempo_Total_de_descarga').get('Tempo_Total_de_descarga').setValue(this.generalService.timeDiffCalc(dateTimeA, dateTimeB))
  }
  private calcTempoEspera() {


    const dataTerminoEnchimento = this.getFormCard('Termino_enchimento_data').get('Termino_enchimento_data').value
    const horaTerminoEnchimento = this.getFormCard('Termino_enchimento_hora').get('Termino_enchimento_hora').value

    const dataSaida = this.getFormCard("Saida_campo_data").get('Saida_campo_data').value;
    const horaSaida = this.getFormCard("Saida_campo_hora").get('Saida_campo_hora').value;
    if (!dataTerminoEnchimento || !horaTerminoEnchimento || !dataSaida || !horaSaida) {
      return
    }
    const dateTimeA = this.generalService.createDateTimeData(dataSaida, horaSaida)
    const dateTimeB = this.generalService.createDateTimeData(dataTerminoEnchimento, horaTerminoEnchimento)
    // const duration = moment.duration(dateTimeA.diff(dateTimeB));

    // const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
    // const minutes = String(duration.minutes()).padStart(2, '0');
    this.getFormCard('Tempo_espera_campo').get('Tempo_espera_campo').setValue(this.generalService.timeDiffCalc(dateTimeA, dateTimeB))
  }


  private validateChronologicalOrder(dateTimePairs: { dataField: string, horaField: string, alias: string }[]): void {
    for (let i = 1; i < dateTimePairs.length; i++) {
      const previous = this.getDateTimeValue(dateTimePairs[i - 1].dataField, dateTimePairs[i - 1].horaField);
      const current = this.getDateTimeValue(dateTimePairs[i].dataField, dateTimePairs[i].horaField);
      previous.time = dateTimePairs[i - 1].horaField == null ? '0000' : previous.time
      if (dateTimePairs[i].dataField == 'Dt_colheita') {
        continue
      }
      if (!current.date || !current.time) {
        return;
      }

      if (!this.generalService.isDateTimeBGreaterThanA(previous.date, previous.time, current.date, current.time)) {
        this.setFieldError(dateTimePairs[i].dataField, `Data/Hora de ${dateTimePairs[i].alias} não pode ser menor que ${dateTimePairs[i - 1].alias}`);
        return;
      } else {
        this.clearFieldError(dateTimePairs[i].dataField);
      }
    }
  }


  private getDateTimeValue(dataField: string, horaField: string): { date: string, time: string } {
    const date = this.getFormCard(dataField)?.get(dataField)?.value;
    const time = this.getFormCard(horaField)?.get(horaField)?.value;
    return { date, time };
  }

  private setFieldError(field: string, message: string): void {
    this.notificationService.sendNotification(message, TypeMessage.Personalized, ActionMessage.Info);
    this.getFormCard(field).get(field).setErrors({ invalidDatas: true });
  }
  private setControlError(control: AbstractControl, message: string): void {
    this.notificationService.sendNotification(message, TypeMessage.Personalized, ActionMessage.Info);
    control.setErrors({ invalidDatas: true });
  }

  private clearFieldError(field: string): void {
    this.getFormCard(field).get(field).setErrors(null);
    this.getFormCard(field).get(field)?.updateValueAndValidity();
    this.getFormCard(field).get(field)?.markAsTouched();
  }
  private clearControlError(control: AbstractControl): void {
    control.setErrors(null);
    control?.updateValueAndValidity();
    control?.markAsTouched();
  }
  private validatePesoItem() {
    let pesoRw = 0
    this.qua007CardIVComponent.pesosItemReferences.forEach(pesoItem => {
      const dateInicioPesagem = pesoItem.instance.formulario.get('Inicio_pesagem_data')?.value
      const horaInicioPesagem = pesoItem.instance.formulario.get('Inicio_pesagem_hora')?.value

      const dateTerminoPesagem = pesoItem.instance.formulario.get('Termino_pesagem_data')?.value
      const horaTerminoPesagem = pesoItem.instance.formulario.get('Termino_pesagem_hora')?.value

      const dateTerminoDescarga = this.getFormCard('Termino_descarga_data').get('Termino_descarga_data')?.value
      const horaTerminoDescarga = this.getFormCard('Termino_descarga_hora').get('Termino_descarga_hora')?.value


      const dateTimePairs = [
        {
          date: dateTerminoDescarga,
          time: horaTerminoDescarga,
          alias: 'Término Descarga Data Hora',
          control: this.getFormCard('Termino_descarga_data').get('Termino_descarga_data')
        },
        {
          date: dateInicioPesagem,
          time: horaInicioPesagem,
          alias: 'Início Pesagem Data Hora',
          control: pesoItem.instance.formulario.get('Inicio_pesagem_data')
        },
        {
          date: dateTerminoPesagem,
          time: horaTerminoPesagem,
          alias: 'Término da Pesagem Data',
          control: pesoItem.instance.formulario.get('Termino_pesagem_data')
        }
      ]
      this.validateChronologicalOrderByDate(dateTimePairs)
      pesoRw += pesoItem.instance.formulario.get('Peso_liquido')?.value || 0
    })
    this.setPesoRw(pesoRw);
  }

  private validateChronologicalOrderByDate(dateTimePairs: { date: string, time: string, alias: string, control: AbstractControl }[]): void {
    for (let i = 1; i < dateTimePairs.length; i++) {
      const previous = dateTimePairs[i - 1]
      const current = dateTimePairs[i]

      if (!current.date || !current.time) {
        return;
      }

      if (!this.generalService.isDateTimeBGreaterThanA(previous.date, previous.time, current.date, current.time)) {
        this.setControlError(dateTimePairs[i].control, `Data/Hora de ${dateTimePairs[i].alias} não pode ser menor que ${dateTimePairs[i - 1].alias}`);
        return;
      } else {
        this.clearControlError(dateTimePairs[i].control);
      }
    }
  }
  private setPesoRw(pesoRw: number) {


    this.getFormCard('Peso_total_rw').get('Peso_total_rw')?.setValue(pesoRw)
  }
  public async getPc003DataPreBasica(event?: any): Promise<void> {
    const numeroCampo = this.getFormCard('Nr_campo').get('Nr_campo')?.value as string;
    const safra = this.getFormCard('Safra').get('Safra')?.value as string;


    // FUNCAO PARA BUSCAR DADOS PC003 PARTINDO SOMENTE SAFRA E NUMERO CAMPO

    if (!!numeroCampo && !!safra) {
      await this.formularioService.getPc003Data(null, safra, numeroCampo).pipe(take(1)).toPromise().then(async (objPc003: any) => {

        this.getFormCard('Geracao').get('Geracao').setValue(objPc003?.data?.geracao);
        this.getFormCard('Contrato_Juridico').get('Contrato_Juridico').setValue(objPc003?.data?.contrato_juridico);
        this.getFormCard('Cooperante').get('Cooperante').setValue(objPc003?.data?.cooperante);
        this.getFormCard('hibrido_rnc').get('hibrido_rnc').setValue(objPc003?.data?.hibrido_rnc);

        this.verifyFieldRequired()

      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao numero campo e safra. Entre em contato com o Administrador.`);
      });

    }
  }

  private verifyFieldRequired() {
    const geracao = this.getFormCard('Geracao').get('Geracao').value as string

    if (geracao.includes('G0')) {
      this.getFormCard('Cerar_basica').get('Cerar_basica').setValidators([])
      this.getFormCard('Lote_rw').get('Lote_rw').setValidators([])
      this.getFormCard('Cerar_basica').get('Cerar_basica').updateValueAndValidity();
      this.getFormCard('Lote_rw').get('Lote_rw').updateValueAndValidity()

    } else {
      this.getFormCard('Cerar_basica').get('Cerar_basica').setValidators([Validators.required])
      this.getFormCard('Lote_rw').get('Lote_rw').setValidators([Validators.required, Validators.pattern(this.regexLoteRwPet)])
      this.getFormCard('Cerar_basica').get('Cerar_basica').updateValueAndValidity();
      this.getFormCard('Lote_rw').get('Lote_rw').updateValueAndValidity()
    }
    this.qua007CardIVComponent.pesosItemReferences.forEach(x => {

      if (geracao.includes('G0')) {
        x.instance.formulario.get('Familias_recebidas')?.setValidators([Validators.required])
        x.instance.formulario.get('Familias_recebidas')?.updateValueAndValidity()

      }
      else {
        x.instance.formulario.get('Familias_recebidas')?.setValidators([])
        x.instance.formulario.get('Familias_recebidas')?.updateValueAndValidity()
      }
    })

  }

  private buildListCaixas(): void {

    const quaCaixas: QuaCaixas[] = [];
    this.qua007CardIVComponent.pesosItemReferences.forEach(x => {
      quaCaixas.push({

        id: x.instance.formulario.get('id')?.value,
        numero_caixa: x.instance.formulario.get('numero_da_caixa')?.value,
        peso_bruto: x.instance.formulario.get('Peso_bruto')?.value,
        peso_tara: x.instance.formulario.get('Peso_tara')?.value,
        peso_liquido: x.instance.formulario.get('Peso_liquido')?.value,
        inicio_pesagem: this.generalService.createDateTimeData(x.instance.formulario.get('Inicio_pesagem_data')?.value, x.instance.formulario.get('Inicio_pesagem_hora')?.value),
        termino_pesagem: this.generalService.createDateTimeData(x.instance.formulario.get('Termino_pesagem_data')?.value, x.instance.formulario.get('Termino_pesagem_hora')?.value),
        familias_recebidas: x.instance.formulario.get('Familias_recebidas')?.value,
        altura_camada: x.instance.formulario.get('Altura_camada')?.value,
        controle_caixa: x.instance.formulario.get('controle_caixa')?.value

      } as QuaCaixas)
    });


    this.formulario.get('list_caixas').setValue(quaCaixas);
  }

  public async createPesoItemComponent(data: any): Promise<void> {

    if (!!data.formulario?.list_caixas) {
      const listCaixas = data.formulario.list_caixas as QuaCaixas[]
      this.totalCaixas = data.formulario.list_caixas?.length > 0 ?
        data.formulario.list_caixas?.length > this.qua007CardIVComponent.maxItensOnList ?
          this.qua007CardIVComponent.maxItensOnList :
          data.formulario.list_caixas?.length :
        this.qua007CardIVComponent.minItensOnList;

      for (let j = 0; j < this.totalCaixas; j++) {
        this.qua007CardIVComponent.createPesoItemComponent();
      }

      if (this.qua007CardIVComponent.VCR.length < 1) return;

      for (let key = 0; key < this.totalCaixas; key++) {
        let componentRef = this.qua007CardIVComponent.pesosItemReferences.filter(x => x.instance.unique_key == key)[0];
        // tslint:disable-next-line: max-line-length


        componentRef.instance.btnExcluir = true;
        componentRef.instance.formulario.get('id').setValue(listCaixas[key].id);
        componentRef.instance.formulario.get('numero_da_caixa').setValue(listCaixas[key].numero_caixa);
        componentRef.instance.formulario.get('Peso_bruto').setValue(listCaixas[key].peso_bruto);
        componentRef.instance.formulario.get('Peso_tara').setValue(listCaixas[key].peso_tara);
        componentRef.instance.formulario.get('Peso_liquido').setValue(listCaixas[key].peso_liquido);
        componentRef.instance.formulario.get('Inicio_pesagem_data').setValue(this.generalService.convertStringToDateOrTimeOnly(data.formulario.list_caixas[key].inicio_pesagem, true));
        componentRef.instance.formulario.get('Inicio_pesagem_hora').setValue(this.generalService.convertStringToDateOrTimeOnly(data.formulario.list_caixas[key].inicio_pesagem, false));
        componentRef.instance.formulario.get('Termino_pesagem_data').setValue(this.generalService.convertStringToDateOrTimeOnly(data.formulario.list_caixas[key].termino_pesagem, true));
        componentRef.instance.formulario.get('Termino_pesagem_hora').setValue(this.generalService.convertStringToDateOrTimeOnly(data.formulario.list_caixas[key].termino_pesagem, false));
        componentRef.instance.formulario.get('Familias_recebidas').setValue(listCaixas[key].familias_recebidas);
        componentRef.instance.formulario.get('Altura_camada').setValue(String(listCaixas[key].altura_camada));
        componentRef.instance.formulario.get('controle_caixa').setValue(listCaixas[key].controle_caixa);
      }
    }

    await this.makeCalcPreBasicaII();
  }
  // private verifyDatasPatio() {
  //   const dataSaida = this.getFormCard("Saida_campo_data").get('Saida_campo_data').value;
  //   const horaSaida = this.getFormCard("Saida_campo_hora").get('Saida_campo_hora').value;

  //   const dataChegadaPatio = this.getFormCard('Chegada_patio_data').get('Chegada_patio_data').value
  //   const horaChegadaPatio = this.getFormCard('Chegada_patio_hora').get('Chegada_patio_hora').value
  //   if (!dataChegadaPatio || !horaChegadaPatio) {
  //     return
  //   }
  //   if (!this.generalService.isDateTimeBGreaterThanA(dataSaida, horaSaida, dataChegadaPatio, horaChegadaPatio)) {
  //     this.notificationService.sendNotification(`A Chagada no Pátio Data Hora são menores a Saída Campo Data Hora`, TypeMessage.Personalized, ActionMessage.Info);
  //     this.getFormCard('Chegada_patio_data').get('Chegada_patio_data').setErrors({ invalidDatas: true });

  //   }
  //   else {
  //     this.getFormCard('Chegada_patio_data').get('Chegada_patio_data').setErrors({ invalidDatas: false });
  //     this.getFormCard('Chegada_patio_data').get('Chegada_patio_data')?.updateValueAndValidity();
  //     this.getFormCard('Chegada_patio_data').get('Chegada_patio_data')?.markAsTouched();
  //   }

  // }
}

